import { toast } from '../components/toast/toast.js';
import { COOKIES, DefaultCookieOptions } from '../constants/misc.js';
import { Cookies } from 'react-cookie';

// import { toast } from "../../components/utils/toast/toast";
// This attempt block is common for both GST and Aadhar verification
const blockedKYCVerification = (key) => {
    const cookies = new Cookies();
    // let blockVerification =
    //     key === LOC_STORAGE.aadharVerificationAttempts
    //         ? LOC_STORAGE.blockAadharVerification
    //         : LOC_STORAGE.blockGstVerification;
    let blockVerification = key === COOKIES.aadharVerificationAttempts ? COOKIES.blockAadharVerification : COOKIES.blockGstVerification;
    const blockedTime = 10800000; // 3 hours in ms
    //let attemptedLog = Number(localStorage.getItem(blockVerification));
    let attemptedLog = Number(cookies.get(blockVerification));
    if (Date.now() - attemptedLog > blockedTime) {
        //localStorage.removeItem(blockVerification);
        cookies.remove(blockVerification, DefaultCookieOptions);
        return false;
    }
    toast.error("You have reached maximum attempts, try after some time!");
    // localStorage.removeItem(key);
    cookies.remove(key, DefaultCookieOptions);
    return true;
};
const validateVerificationAttempts = (key) => {
    const cookies = new Cookies();
    // let blockVerification =
    //     key === LOC_STORAGE.aadharVerificationAttempts ? LOC_STORAGE.blockAadharVerification : LOC_STORAGE.blockGstVerification;
    let blockVerification = key === COOKIES.aadharVerificationAttempts ? COOKIES.blockAadharVerification : COOKIES.blockGstVerification;
    // let attempts = Number(localStorage.getItem(key));
    let attempts = Number(cookies.get(key));
    if (attempts === 3) {
        toast.error("You have reached maximum attempts, try after some time!");
        return;
    }
    if (attempts === null) {
        attempts = 0;
    }
    else {
        attempts++;
        // attempts === 3 && localStorage.setItem(blockVerification, String(Date.now()));
        attempts === 3 && cookies.set(blockVerification, String(Date.now()), DefaultCookieOptions);
    }
    toast.error(`You have ${3 - attempts} attempts remaining!`);
    // localStorage.setItem(key, String(attempts));
    cookies.set(key, String(attempts), DefaultCookieOptions);
};

export { blockedKYCVerification, validateVerificationAttempts };
//# sourceMappingURL=validateVerificationAttempts.js.map
